import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { AsyncValidatorFn, ValidatorFn, Validators } from '@angular/forms';
import { DispersedFormGroupService, ReactiveFormItemComponent } from '@csspension/reactive-form';
import { MemberUserSearchResult } from '../../../../models/users/dto/member-user-search-result';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-member-search-input',
  templateUrl: './member-search-input.component.html',
  providers: [
    {
      provide: ReactiveFormItemComponent,
      useExisting: forwardRef(() => MemberSearchInputComponent)
    }
  ]
})
export class MemberSearchInputComponent extends ReactiveFormItemComponent implements OnChanges {
  constructor(elementRef: ElementRef, dispersedFormGroupService: DispersedFormGroupService, cdr: ChangeDetectorRef) {
    super(elementRef, dispersedFormGroupService, cdr);
  }

  @Input() odataFunction!: (searchString: string) => Observable<MemberUserSearchResult[]>;
  @Input() selectedMember: MemberUserSearchResult | null | undefined;
  @Input() disabled: boolean = false;
  @Input() required: boolean = true;
  @Input() clearSearchTrigger: EventEmitter<void> = new EventEmitter<void>();
  @Output() memberSelected = new EventEmitter<MemberUserSearchResult>();

  public getValidators(): ValidatorFn[] {
    if (this.required) {
      return [Validators.required];
    } else {
      return [];
    }
  }

  public getAsyncValidators(): AsyncValidatorFn[] {
    return [];
  }

  public setBindingProperty(): void {
    this.setDataInBindingProperty(this.getMyValue());
  }

  private markAsDirty(): void {
    this?.getSelfAsFormItem()?.markAsDirty();
  }

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.selectedMember) {
      this.handleSelectedMemberChange(this.selectedMember);
    }
  }

  private handleSelectedMemberChange(selectedMember: MemberUserSearchResult | null | undefined): void {
    this.handleInputChange(selectedMember);
    this.getSelfAsFormItem()?.patchValue(selectedMember);
    this.markAsDirty();
  }

  // TODO: SPP-913 Connect this component to a shimmer cell if required
  protected override checkParentElement(): void {}
}
